import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BusinessUser } from '../model/user';
// import { ProductGroup } from '../model/productGroup';
import { GoogleReview } from '../model/googleReview';
import { API_URL_NZ, API_URL_IN } from '../app.component';
import { TokenStorage } from '../token.storage';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ListingService {

  API_URL: string;

  constructor(private http: HttpClient,
    private token: TokenStorage) {
this.setApi();

   }

setApi(){

    this.API_URL = API_URL_IN;
  
}
  findProperties(applicationUser: BusinessUser) {
    this.setApi();
    return this.http.post<BusinessUser[]>(this.API_URL + '/api/website/findProperties', applicationUser, { observe: 'response' });
  }
  // findProductsByBusinessServiceId(businessServiceId: number) {
  //   return this.http.get<ProductGroup[]>(this.API_URL + '/api/website/getProductList/' + businessServiceId, { observe: 'response' });
  // }

  // Not Working
  findByPropertyNameAndSuburb(suburb: string, propertyName: string) {
    this.setApi();
    return this.http.get<BusinessUser>(this.API_URL + '/api/website/findByPropertyNameAndSuburb/' + suburb + '/' + propertyName, { observe: 'response' });
  }
  findByPropertyByCityAndDate(city: string, checkInDate: string, checkOutDate: string, noOfRoom: number, noOfGuest: number) {
this.setApi();

    return this.http.get<BusinessUser[]>(this.API_URL + '/api/website/checkAvailability?city=' + city + '&fromDate=' + checkInDate + '&toDate=' + checkOutDate + '&noOfRooms=' + noOfRoom + '&noOfPersons=' + noOfGuest, { observe: 'response' });
  }
  findPropertyBySEOName(seoFriendlyName: string) {
    this.setApi();
    return this.http.get<BusinessUser>(
      'https://api.thehotelmate.co' +
        '/api/thm/findByPropertyBySEOFriendlyName/' +
        seoFriendlyName,
      { observe: 'response' }
    );
  }

  findByPropertyId(id: number) {
    this.setApi();
    return this.http.get<BusinessUser>(this.API_URL + '/api/website/findByPropertyId/' + id, { observe: 'response' });
  }

  getBusinessBranch(id) {
    this.setApi();
    return this.http.get<any[]>(this.API_URL + '/api/website/' + id + '/branches', { observe: 'response' });
  }

  getAllReview(propertyId: number) {
    this.setApi();
    return this.http.get<GoogleReview[]>(this.API_URL + '/api/website/getGoogleReviews?PropertyId=' + propertyId, { observe: 'response' });
  }

  getPropertiesByLocality(locality: String) {
    this.setApi();
    return this.http.get<BusinessUser[]>(this.API_URL + '/api/website/getPropertiesByLocality/' + locality, { observe: 'response' });
  }
}
